import { createSlatePlugin } from "platejs";
import {
  markdownSupportedMarkTypes,
  markdownSupportedNodeTypes,
} from "./base-plate-component-overrides";

export const MarkdownNormalizationPlugin = createSlatePlugin({
  key: "normalize-unknown-elements",
  extendEditor: ({ editor }) => {
    // https://docs.slatejs.org/concepts/11-normalizing
    // save reference to the existing normalizeNode function so we can
    // call it for nodes we don't need to handle. This preserves the
    // normalization chain. Every Plate/Slate plugin wraps the previous
    // normalizeNode, so we're just adding a new link to the chain
    const originalNormalizeNode = editor.normalizeNode;
    // the set of node types that the MarkdownEditor's markdown serializer
    // can handle. Any node type NOT in this set will be silently dropped
    // during serialization, causing content loss
    const knownTypes = new Set<string>(markdownSupportedNodeTypes);

    const knownMarks = new Set<string>(markdownSupportedMarkTypes);

    // override normalizeNode. Slate calls this for every node in the tree
    // after any change
    editor.normalizeNode = (entry: any) => {
      const [node, path] = entry;

      // Strip unknown marks from text leaves
      if ("text" in node) {
        const unknownMarks = Object.keys(node).filter(
          (key) => key !== "text" && !knownMarks.has(key) && node[key] === true,
        );

        if (unknownMarks.length > 0) {
          editor.tf.unsetNodes(unknownMarks, { at: path });
          return;
        }
      }

      // Unwrap unknown element types
      if (
        "type" in node &&
        "children" in node &&
        path.length > 0 &&
        !knownTypes.has(node.type as string)
      ) {
        // "unwrap" removes the unknown wrapper node but keeps its children,
        // promoting them into the parent
        editor.tf.unwrapNodes({ at: path });
        return;
      }
      // node is a known type, pass it to the rest of the normalization
      // chain so all other plugin rules (list normalization, etc.) still run
      (originalNormalizeNode as any)(entry);
    };

    return editor;
  },
});
